



















import Vue from 'vue';
import Component from 'vue-class-component';
import { Employee, Department, departmentApis, employeeApis } from '../../api';

@Component
export default class MyInfo extends Vue {
  readonly labelWidth = '4rem';
  readonly rules = {};

  employee!: Employee;
  departments: Array<Department> | null = null;

  created() {
    this.employee = this.$store.getters['employee/get'];
  }

  mounted() {
    departmentApis.myDepartments().then(deps => (this.departments = deps));
  }

  async logout() {
    await employeeApis.logout();
    location.reload();
  }
}
